import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { Layout } from "@/components/nyla/Layout";
import { ScrollToTop } from "@/components/nyla/ScrollToTop";
import Home from "@/pages/Home";
import Innovation from "@/pages/Innovation";
import ProductsPage from "@/pages/ProductsPage";
import SustainabilityPage from "@/pages/SustainabilityPage";
import VisionPage from "@/pages/VisionPage";
import Journal from "@/pages/Journal";
import WaterIntelligence from "@/pages/WaterIntelligence";
import SustainabilityPolicy from "@/pages/SustainabilityPolicy";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import ContactPage from "@/pages/ContactPage";
import BlogPost from "@/pages/BlogPost";
import Admin from "@/pages/Admin";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/innovation" element={<Innovation />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/sustainability" element={<SustainabilityPage />} />
              <Route path="/vision" element={<VisionPage />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/water-intelligence" element={<WaterIntelligence />} />
              <Route path="/sustainability-policy" element={<SustainabilityPolicy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/contact" element={<ContactPage />} />
            </Route>
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#FFFFFF",
              border: "1px solid #D2D2D7",
              color: "#1D1D1F",
              borderRadius: "16px",
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
